import React from 'react';

const ApplyPage = () => {
  return (
    <div className="fixed inset-0 w-screen h-screen bg-[#f5f3f0]">
      <iframe
        src="https://karmanbeyond.typeform.com/to/sMs1jlsZ"
        title="Membership Application Form"
        frameBorder="0"
        allow="camera; microphone; autoplay; encrypted-media;"
        className="w-full h-full border-0 block"
      ></iframe>
    </div>
  );
};

export default ApplyPage;
